/**
 * Shown when the host is a *.zelospace.com subdomain with no tenant behind it.
 *
 * Wildcard DNS and a wildcard certificate mean any subdomain reaches the app,
 * so without this an unregistered name renders the app shell and then fails
 * silently - a blank or half-broken page. This says plainly that the space
 * does not exist and points somewhere useful.
 */

const TenantNotFound = () => (
  <div className="min-h-screen w-full bg-stone-brown text-swan flex items-center justify-center px-6">
    <div className="max-w-md text-center">
      <h1 className="text-4xl font-extrabold mb-4">This space doesn't exist</h1>
      <p className="text-field-grey mb-8">
        <span className="text-swan">{window.location.hostname}</span> isn't a
        Zelospace space. It may have been renamed, or the address may be
        mistyped.
      </p>
      <a
        href="https://zelospace.com"
        className="inline-block px-8 py-4 rounded-2xl bg-imperial-red text-swan font-semibold transition-colors hover:bg-[#d32a32]"
      >
        Go to Zelospace
      </a>
      <p className="text-field-grey/70 text-sm mt-8">
        Want your own space?{' '}
        <a href="https://zelospace.com/partner" className="underline hover:text-imperial-red">
          Request one
        </a>
        .
      </p>
    </div>
  </div>
);

export default TenantNotFound;
